import { CSSProperties, SVGProps } from 'react';

import { COLORS } from '../../../lib';

interface ICardIconProps extends SVGProps<SVGSVGElement> {
  color?: CSSProperties['color'];
}

export const CardIcon = ({ color, ...props }: ICardIconProps) => {
  const fill = color ?? COLORS['base-100'];

  return (
    <svg
      width="21"
      height="15"
      viewBox="0 0 21 15"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.47631 1.09835C0.851189 1.80161 0.5 2.75544 0.5 3.75V11.25C0.5 12.2446 0.851189 13.1984 1.47631 13.9017C2.10143 14.6049 2.94928 15 3.83333 15H17.1667C18.0507 15 18.8986 14.6049 19.5237 13.9017C20.1488 13.1984 20.5 12.2446 20.5 11.25V3.75C20.5 2.75544 20.1488 1.80161 19.5237 1.09835C18.8986 0.395089 18.0507 0 17.1667 0H3.83333C2.94928 0 2.10143 0.395089 1.47631 1.09835ZM12.5 11.0769C12.5 10.4822 12.9822 10 13.5769 10H16.8077C17.4025 10 17.8846 10.4822 17.8846 11.0769C17.8846 11.6717 17.4025 12.1538 16.8077 12.1538H13.5769C12.9822 12.1538 12.5 11.6717 12.5 11.0769ZM5 6C5.82843 6 6.5 5.32843 6.5 4.5C6.5 3.67157 5.82843 3 5 3C4.17157 3 3.5 3.67157 3.5 4.5C3.5 5.32843 4.17157 6 5 6Z"
        fill={fill}
      />
    </svg>
  );
};
